import axios from "axios";
import { api } from "./helper";
import store from "../../store/store"
import { v4 as uuidv4 } from 'uuid';

function prepareDataRequest(data) {
  return {
    RequestCorrelationId: uuidv4(),
    Data: data
  };
}

export function prepareRequest(data) {
  return {
    ...data,
    RequestCorrelationId: uuidv4()
  };
}


const client = axios.create({
    baseURL: api,
    withCredentials: false,
});

client.interceptors.request.use((config) => {
    config.headers.Authorization = "Bearer " + store.state.user.jwt;
    return config;
});

function CreateCourtDecision(item) {
    return client.post("CourtDecisions/CreateCourtDecision", prepareDataRequest(item));
}

function GetCourtDecision(courtCaseId) {
  const data = { courtCaseId: courtCaseId };
  return client.post("CourtDecisions/GetCourtDecision/", prepareRequest(data));
}

export {
    CreateCourtDecision,
    GetCourtDecision
}